import reducers from "./reducers";

const helperReducers = {
  reduxLoading: reducers.loadingReducer,
};

export { helperReducers };
